// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2v-2";
export var placeholderIcon = "_2v-3";
export var thumbnailCanvas = "_2v-1";
export var thumbnailWrapper = "_2v-0";